import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, ShieldIcon } from './Icons';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden pt-12" aria-label="Hero" data-id="element-132">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-133">
        <img src="https://cdn.magicpatterns.com/uploads/dwc6iqVK19yJEFV3kPnHNH/Hero_1-1.png" alt="" className="w-full h-full object-cover" aria-hidden="true" data-id="element-134" />
        {/* Dark overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[#0a0f0a]" data-id="element-135" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/50" data-id="element-136" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center py-20" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease: 'easeOut'
      }} data-id="element-138">
          {/* Eyebrow */}
          <p className="font-sans text-xs sm:text-sm tracking-[0.25em] uppercase text-gold/80 mb-8" data-id="element-139">
            The Longevity Bowl
          </p>

          {/* Main Headline */}
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-cream leading-[1.15] mb-8" data-id="element-140">
            How to Add <span className="text-gold" data-id="element-141">5+ Years</span> to Your Dog's
            Life
            <br className="hidden md:block" data-id="element-142" /> in Just{' '}
            <span className="text-gold" data-id="element-143">60 Seconds</span> a Day.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.3,
        ease: 'easeOut'
      }} data-id="element-144">
          {/* Subheadline */}
          <p className="font-sans text-base sm:text-lg md:text-xl text-cream/80 leading-relaxed max-w-2xl mx-auto mb-2" data-id="element-145">
            The Ancestral Nutrition Blueprint for Giant Breeds.
          </p>
          <p className="font-sans text-base sm:text-lg md:text-xl text-cream/60 leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-146">
            Learn the exact{' '}
            <span className="font-semibold text-gold" data-id="element-147">20% fresh food rule</span>{' '}
            to slash chronic disease risk.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} data-id="element-148">
          {/* CTA Button */}
          <a href="#pricing" className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-gold text-bg-primary font-sans font-bold text-sm sm:text-base rounded tracking-wide transition-all duration-300 hover:bg-gold-bright hover:shadow-[0_0_30px_rgba(200,168,78,0.3)]" aria-label="Get the blueprint now" data-id="element-149">
            GET THE BLUEPRINT
          </a>

          {/* Guarantee Badge */}
          <div className="mt-6 flex flex-col items-center gap-2" data-id="element-150">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm" data-id="element-151">
              <ShieldIcon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-152" />
              <span className="font-sans text-xs sm:text-sm font-semibold text-cream" data-id="element-153">
                30-Day Money Back Guarantee
              </span>
            </div>
            <p className="font-sans text-xs text-cream-muted/70" data-id="element-154">
              100% Risk-Free. If he doesn't thrive, you don't pay.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-155">
        <a href="#pain" aria-label="Scroll down" data-id="element-156">
          <ArrowDownIcon className="w-6 h-6 text-cream/40" data-id="element-157" />
        </a>
      </motion.div>
    </section>;
}